module.exports = __webpack_public_path__ + "static/media/TaipeiSansTCBeta-Regular.7cf11eed.ttf";